var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRuby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_1228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.8071 38.8071 50 25 50C16.5725 50 9.11836 45.8296 4.58984 39.4398C4.58984 39.4398 4.58984 39.4398 4.58887 39.4398C3.43789 37.8153 2.47559 36.048 1.73477 34.1685C1.36025 33.2185 1.04189 32.2409 0.784766 31.2379C0.784766 31.2379 0.784766 31.2379 0.784766 31.2369C0.272461 29.2429 0 27.153 0 25C0 11.1929 11.1929 0 25 0C32.7326 0 39.6449 3.51016 44.2296 9.02451C45.8857 11.0144 47.2378 13.2653 48.2153 15.7062C49.3663 18.5796 50 21.7163 50 25Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2152 15.7061C48.2132 15.7256 48.2111 15.746 48.2091 15.7663C48.0713 17.002 47.6815 18.3316 47.0591 19.7112L47.0581 19.7122L36.2948 47.1L7.46621 40.3387C7.11211 40.2693 6.76826 40.1887 6.43564 40.0969C5.77344 39.9174 5.15703 39.6979 4.58975 39.4398C4.58975 39.4398 4.58975 39.4398 4.58877 39.4398C2.85615 36.9939 1.55098 34.2235 0.784668 31.2378C0.87041 30.8796 1.00811 30.3265 1.18975 29.6469C1.88975 27.0256 3.2499 22.5327 4.88467 20.1704L5.04385 25.6357L15.8152 26.3541L30.4162 19.4123L36.7192 10.1572L33.9274 5.68884C38.5846 6.81843 41.5356 7.83884 43.3937 8.64392C43.702 8.77654 43.9795 8.90408 44.2295 9.02449C46.0958 9.92546 46.454 10.4735 46.454 10.4735C47.0693 10.9919 47.5306 11.6001 47.8111 12.296C48.2193 13.3061 48.3469 14.4582 48.2152 15.7061Z",
    fill: "#9B0A0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8321 8.18144C33.0217 4.61548 25.0327 5.03555 16.988 9.11968C8.94334 13.2038 3.88945 19.4054 5.69982 22.9714C7.51019 26.5373 15.4993 26.1173 23.5439 22.0331C31.5886 17.949 36.6425 11.7474 34.8321 8.18144Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.412 36.0466L36.2944 47.1004L18.1643 39.9842C21.7436 39.2454 25.587 37.9392 29.412 36.0466Z",
    fill: "#F5655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88462 20.1705L5.04419 25.636L1.1897 29.6469C1.89019 27.0258 3.24976 22.5329 4.88462 20.1705Z",
    fill: "#F5655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04385 25.6357L1.73467 34.1684C1.36016 33.2184 1.0418 32.2408 0.784668 31.2378C0.784668 31.2378 0.784668 31.2378 0.784668 31.2368C0.871387 30.8786 1.00811 30.3256 1.18975 29.6471L5.04385 25.6357Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72 10.1571L48.2093 15.7662C48.0712 17.0021 47.682 18.3314 47.0588 19.7117L47.0581 19.7125C46.5921 20.7466 45.9945 21.8093 45.2748 22.8816L36.72 10.1571Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0577 19.7125L36.2944 47.1002L39.0511 29.7297C41.6313 27.522 43.7338 25.1794 45.2745 22.8816C45.9942 21.8092 46.5917 20.7464 47.0577 19.7125Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7198 10.1571L45.2746 22.8816L30.4165 19.4126L36.7198 10.1571Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3945 8.64351L36.7203 10.1571L33.9277 5.68823C38.585 6.8188 41.5363 7.83853 43.3945 8.64351Z",
    fill: "#F5655E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4166 19.4126L39.0512 29.73C36.4541 31.9528 33.3735 34.0393 29.8924 35.8066C29.7319 35.8881 29.5725 35.9678 29.4121 36.0469L30.4166 19.4126Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.417 19.4125L29.4125 36.0465L15.8159 26.3539L30.417 19.4125Z",
    fill: "#EF0E13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8159 26.3539L29.4124 36.0465C25.5874 37.939 21.744 39.2451 18.1647 39.9841L15.8159 26.3539Z",
    fill: "#950C10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.815 26.3539L6.43521 40.0974L5.0437 25.6359L15.815 26.3539Z",
    fill: "#F5655E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_1228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuby);
export default __webpack_public_path__ + "static/media/icon_ruby.c1f14b0cc358ff026ceea3f6f650b959.svg";
export { ForwardRef as ReactComponent };